import { FC } from "react";
import styled from "styled-components";
import { isToday } from "date-fns";
import { Text } from "shared/components/typography/TitleStyles";
import {
  formatDateString,
  formatDateTimeString,
} from "shared/utils/dateTimeUtils";
import { StaticCard } from "@vygruppen/spor-react";

const LogListItem = styled(StaticCard).attrs({
  padding: 3,
})`
  display: grid;
  grid-template-areas:
    "time . sender"
    "message message message";
  column-gap: 6px;
  row-gap: 6px;
`;

interface Props {
  timestamp: string;
  message: string | null;
  source?: string | null;
  fallbackSource: string;
}

export const LogEntry: FC<Props> = ({
  timestamp,
  message,
  source,
  fallbackSource,
}) => (
  <LogListItem>
    <Text style={{ gridArea: "time" }}>{formatDateTimeString(timestamp)}</Text>
    <Text style={{ gridArea: "message" }}>{message}</Text>
    {!isToday(new Date(timestamp)) && (
      <Text
        secondary
        style={{
          gridRow: 2,
          gridColumn: "1 / span 2",
        }}
      >
        {formatDateString(timestamp, "dd.MM.yy")}
      </Text>
    )}
    <Text
      secondary
      style={{
        gridRow: 2,
        gridColumn: 2,
        marginLeft: "auto",
        gridArea: "sender",
      }}
    >
      {source ?? fallbackSource}
    </Text>
  </LogListItem>
);
